import { Badge } from '@bambi/component-library/src/components/Badge/Badge';

import { SeatEquipmentEnum } from 'src/common/external/bambi-api/bambiApi';

export function SeatEquipmentBadge({
  seatEquipment,
}: {
  seatEquipment: SeatEquipmentEnum;
}) {
  const labels: Record<SeatEquipmentEnum, string> = {
    'booster-seat': 'Booster Seat',
    'car-seat': 'Car Seat',
  };

  const color = {
    'booster-seat': 'blue',
    'car-seat': 'green',
  };
  return <Badge color={color[seatEquipment]} label={labels[seatEquipment]} />;
}
